import {FiltersModule} from 'filters/module';
import {an} from 'filters/indefiniteArticle';
import {formatMoment} from 'filters/formatMoment';
import {capitalizeFirst} from 'filters/capitalizeFirst';
import {collectionWhere} from 'filters/collectionWhere';
import {swathHourlyRange} from "../../angular-utilities/filters/swathHourlyRange";

export default FiltersModule.
    filter('an', an).
    filter('formatMoment', formatMoment).
    filter('capitalizeFirst', capitalizeFirst).
    filter('collectionWhere', collectionWhere).
    filter('swathHourlyRange', swathHourlyRange);
